import BaseWidget from '@/plugins/dashboard/classes/BaseWidget'
import Widget from '@/components/Dashboard/MetricWidget'
import createConfigure from '@/plugins/dashboard/widgets/Base/createConfigure'
import { metric } from '@/plugins/dashboard/widgets/Base/definitions'

export default class extends BaseWidget {
  static name = metric.name
  static widget = Widget
  static configure = createConfigure(metric)
}
